import Button from "../../../../common/button/Button";
import TextField from "../../../../common/text-field/TextField";
import DocumentUpload from "../../../../common/document";
import { ColumnDef, CustomTable } from "../../../../common/table";
import DatePickerField from "../../../../common/date-picker/DatePicker";

export interface Experience {
  organization: string;
  designation: string;
  startDate: string;
  endDate: string;
  document: File | null;
}

interface Props {
  experiences: Experience[];
  errors: any;
  handleExperienceChange: (
    index: number,
    field: keyof Experience,
    value: string | File | null,
  ) => void;
  addExperience: (
    e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>,
  ) => void;
  removeExperience: (index: number) => void;
}

const ExperienceDetails = ({
  experiences,
  errors,
  handleExperienceChange,
  addExperience,
  removeExperience,
}: Props) => {
  const columns: ColumnDef<Experience>[] = [
    {
      header: "Organization",
      className: "pr-2 pl-2",
      render: (experience, index) => (
        <TextField
          name="organization"
          value={experience.organization}
          onChange={(e) =>
            handleExperienceChange(index, "organization", e.target.value)
          }
          placeholder="Organization"
        />
      ),
    },
    {
      header: "Position",
      className: "pr-2 pl-2",
      render: (experience, index) => (
        <TextField
          name="designation"
          value={experience.designation}
          onChange={(e) =>
            handleExperienceChange(index, "designation", e.target.value)
          }
          placeholder="Designation"
        />
      ),
    },
    {
      header: "Start Date",
      className: "pr-2 pl-2",
      render: (experience, index) => (
        <DatePickerField
          name="startDate"
          value={experience.startDate}
          onChange={(date: string): void =>
            handleExperienceChange(index, "startDate", date)
          }
          maxDate={new Date()}
        />
      ),
    },
    {
      header: "End Date",
      className: "pr-2 pl-2",
      render: (experience, index) => (
        <DatePickerField
          name="endDate"
          value={experience.endDate}
          onChange={(date: string): void =>
            handleExperienceChange(index, "endDate", date)
          }
          maxDate={new Date()}
        />
      ),
    },
    {
      header: "Experience Letter",
      className: "pr-2 pl-2",
      render: (_, index) => (
        <DocumentUpload
          name="document"
          onChange={(file) =>
            handleExperienceChange(index, "document", file || null)
          }
          label={""}
        />
      ),
    },
    {
      header: "",
      className: "pr-0 pl-0",
      render: (_, index) => {
        return (
          <>
            {index > 0 && (
              <Button
                onClick={() => removeExperience(index)}
                variant="danger"
                size="sm"
                leftIcon={<i className="fa-solid text-secondary fa-xmark"></i>}
              />
            )}
          </>
        );
      },
    },
  ];
  return (
    <div className="bg-transparent p-1 sm:p-4">
      <div className="flex items-center justify-between border-b pb-3 mb-6">
        <h2 className="text-xl text-white font-medium">Experience Details</h2>

        <Button
          name="Add Experience"
          size="sm"
          type="button"
          onClick={addExperience}
          leftIcon={<i className="fa-solid fa-plus"></i>}
        />
      </div>

      <div className={`bg-white py-4`}>
        <CustomTable columns={columns} data={experiences} />
      </div>
    </div>
  );
};

export default ExperienceDetails;
